import { Fragment, useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Button, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import FilePageService from "../../API/FilePage/FilePageService";
import { MultiSelect } from "react-multi-select-component";
import Select from "react-select";

const AddMyProduct = (props) => {
  const { t } = useTranslation();

  const {
    showmodal,
    handleModalClose,
    handleAddModalCloseAfterAPICall,
    qRBasisList,
    insurerProductList,
    logicalBlockList
  } = props;

  const [flashMessage, setFlashMessage] = useState({ type: "", message: "" });
  const [loading, setLoading] = useState(false);

  const [selectQRBasis, setSelectQRBasis] = useState([]);
  const [selectQuestion, setSelectQuestion] = useState([]);
  const [selectProduct, setSelectProduct] = useState([]);
  const [selectLogicalBlock, setSelectLogicalBlock] = useState([]);
  const [questionsList, setQuestionsList] = useState([]);

  useEffect(() => {
    if (flashMessage.message) {
      const timer = setTimeout(() => {
        setFlashMessage({ type: "", message: "" });
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [flashMessage]);

  useEffect(() => {
    if (showmodal && (selectQRBasis?.value || selectLogicalBlock?.value)) {
      QuestionsList(selectQRBasis?.value, selectLogicalBlock?.value);
    }
  }, [showmodal, selectQRBasis, selectLogicalBlock]);

  useEffect(() => {
    setSelectQRBasis([]);
    setSelectQuestion([]);
    setSelectProduct([]);
    setSelectLogicalBlock([]);
  }, [handleModalClose, showmodal]);

  const QuestionsList = async (qrBasisId, logicalBlockId) => {
    try {
      var userData = {
        qr_basis_id: qrBasisId,
        logical_block_id: logicalBlockId
      }

      const response = await FilePageService.user_questions_list(userData);

      if (response.data.status) {
        const formatted =
          response.data.questionsList?.map((item) => ({
            name: item.question_text,
            id: item.id,
          })) || [];
        setQuestionsList(formatted);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const AddProduct = async (e) => {
    e.preventDefault();
    if (loading) return;

    if (
      selectQRBasis.length === 0 ||
      selectQuestion.length === 0 ||
      selectProduct.length === 0
    ) {
      setFlashMessage({
        type: "error",
        message: t("requriedErrorMessageLabel"),
      });
      return;
    }

    setLoading(true);

    const payload = {
      product_id: selectProduct ? selectProduct?.value : "",
      qr_basis_ids: selectQRBasis ? selectQRBasis?.value : "",
      question_ids: selectQuestion.map((q) => q.value),
      logical_block_id: selectLogicalBlock ? selectLogicalBlock?.value : ""
    };

    try {
      const response = await FilePageService.my_product_create(payload);

      if (response.data.status) {
        setLoading(false);
        handleAddModalCloseAfterAPICall();
      } else {
        setLoading(false);
        setFlashMessage({
          type: "error",
          message: response.data.message || t("somethingWentWrong"),
        });
      }
    } catch (error) {
      setLoading(false);
      setFlashMessage({
        type: "error",
        message: error.response?.data?.message || t("somethingWentWrong"),
      });
    } finally {
      setLoading(false);
    }
  };

  const QRBasisOptions =
    qRBasisList?.map((item) => ({
      label: item.name
        .replace(/_/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase()),
      value: item.id,
    })) || [];

  const QuestionsOptions =
    questionsList?.map((item) => ({
      label: item.name
        .replace(/_/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase()),
      value: item.id,
    })) || [];

  const InsurerProductOptions =
    insurerProductList?.map((item) => ({
      label: item.name
        .replace(/_/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase()),
      value: item.id,
    })) || [];

  const LogicalBlockOptions =
    logicalBlockList?.map((item) => ({
      label: item.name
        .replace(/_/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase()),
      value: item.id,
    })) || [];

  return (
    <Fragment>
      <Modal
        className="missing-doc-modal invalid-doc-modal"
        show={showmodal}
        onHide={handleModalClose}
      >
        <Form onSubmit={AddProduct}>
          <Modal.Header closeButton>
            <Modal.Title>Ajouter mon produit</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h2>Ajouter mon produit</h2>

            {flashMessage.message && (
              <div
                className={`mt-3 mx-w-620 alert ${flashMessage.type === "success"
                  ? "alert-success"
                  : "alert-danger"
                  } text-center`}
                role="alert"
              >
                {flashMessage.message}
              </div>
            )}

            <div className="mt-3">
              <Form.Group className="mb-3">
                <Form.Label>
                  Produits <span>*</span>
                </Form.Label>
                <Select
                  options={InsurerProductOptions}
                  value={selectProduct}
                  onChange={(selectedOption) =>
                    setSelectProduct(selectedOption)
                  }
                  styles={{
                    container: (provided) => ({
                      ...provided,
                      width: "100%",
                    }),
                    menu: (provided) => ({
                      ...provided,
                      width: "100%",
                    }),
                  }}
                  placeholder={"Sélectionnez un produit"}
                  isSearchable={true}
                  noOptionsMessage={() => t("NorecordsfoundLabel")}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>
                  Base QR <span>*</span>
                </Form.Label>
                <Select
                  options={QRBasisOptions}
                  value={selectQRBasis}
                  onChange={(selectedOption) =>
                    setSelectQRBasis(selectedOption)
                  }
                  styles={{
                    container: (provided) => ({
                      ...provided,
                      width: "100%",
                    }),
                    menu: (provided) => ({
                      ...provided,
                      width: "100%",
                    }),
                  }}
                  placeholder={"Sélectionnez la base QR"}
                  isSearchable={true}
                  noOptionsMessage={() => t("NorecordsfoundLabel")}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Bloc logique</Form.Label>
                <Select
                  options={LogicalBlockOptions}
                  value={selectLogicalBlock}
                  onChange={(selectedOption) =>
                    setSelectLogicalBlock(selectedOption)
                  }
                  styles={{
                    container: (provided) => ({
                      ...provided,
                      width: "100%",
                    }),
                    menu: (provided) => ({
                      ...provided,
                      width: "100%",
                    }),
                  }}
                  placeholder={"Sélectionnez le bloc logique"}
                  isSearchable={true}
                  noOptionsMessage={() => t("NorecordsfoundLabel")}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>
                  Questions <span>*</span>
                </Form.Label>
                <MultiSelect
                  options={QuestionsOptions}
                  value={selectQuestion}
                  onChange={(selectedOption) =>
                    setSelectQuestion(selectedOption)
                  }
                  labelledBy="Select questions"
                  overrideStrings={{
                    selectSomeItems: "sélectionner une option",
                    allItemsAreSelected:
                      "Toutes les options sont sélectionnées",
                    selectAll: "Tout sélectionner",
                    search: "Recherche",
                  }}
                />
              </Form.Group>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="cancel-btn"
              variant="primary"
              onClick={handleModalClose}
            >
              {t("cancelLabel")}
            </Button>
            <Button variant="primary" type="submit" disabled={loading}>
              Ajouter
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </Fragment>
  );
};

export default AddMyProduct;
